import {
  AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output,
  ViewChild
} from '@angular/core'
import { FormGroup } from '@angular/forms'
import { Observable } from 'rxjs/Observable'
import { fromEvent } from 'rxjs/observable/fromEvent'
import { debounceTime, distinct, distinctUntilChanged, filter, map, takeUntil, throttleTime } from 'rxjs/operators'
import { Subject } from 'rxjs/Subject'

import { CommonComponent } from '../common.component'
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material'
import { environment } from '../../../environments/environment'
import { Item } from './item'
import { Attribute } from '../attribute/attribute'

const rowHeight = 48
const pageSize = environment.autocomplete.pageSize

@Component({
  selector: 'app-autocomplete-paginated',
  templateUrl: './autocomplete-paginated.component.html',
  styleUrls: ['./autocomplete-paginated.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutocompletePaginatedComponent extends CommonComponent implements AfterViewInit {

  @ViewChild('input') input: ElementRef
  @ViewChild(MatAutocomplete) autoComplete: MatAutocomplete
  @ViewChild(MatAutocompleteTrigger) autoCompleteTrigger: MatAutocompleteTrigger
  @Input() parent: FormGroup
  @Input() placeholder: string
  @Input() attribute: Attribute
  @Input() width = '180px'
  @Input() items: Item[]
  @Output() searchTerm = new EventEmitter<string>()
  @Output() select = new EventEmitter<Item>()
  nextPage = new Subject()

  constructor() {
    super()
  }

  get invalid() {
    const ctrl = this.parent.get(this.attribute.value)

    const required = ctrl.hasError('required') && ctrl.touched
    return {required}
  }

  ngAfterViewInit(): void {
    const search$ = fromEvent(this.input.nativeElement, 'keyup').pipe(
      map(event => (event as any).target.value.trim()),
      filter(value => value.length >= 1),
      debounceTime(500),
      distinctUntilChanged())

    search$.pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe(term => this.searchTerm.emit(term))

    this.autoCompleteTrigger.autocomplete.optionSelected.pipe(
      map(event => event.option),
      takeUntil(this.ngUnsubscribe))
      .subscribe(option => this.select.emit(option.value))

    this.autoCompleteTrigger.panelClosingActions.pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe(e => {
        if (!(e && e.source)) {
          this.parent.get(this.attribute.value).setValue(null)
          this.autoCompleteTrigger.closePanel()
        }
      })
  }

  initPagination() {
    setTimeout(() => {
      if (!this.autoComplete.panel) {
        return
      }

      fromEvent(this.autoComplete.panel.nativeElement, 'scroll').pipe(
        map((event: any) => event.target),
        // emits scroll event 'clientHeight' distance before bottom of the panel
        filter(x => x.scrollTop + 2 * x.clientHeight >= x.scrollHeight),
        map(x => Math.ceil(x.scrollTop / (rowHeight * pageSize / 2))), // emits page number
        map(x => x + this.input.nativeElement.value),
        throttleTime(100),
        distinct(),
        takeUntil(this.autoCompleteTrigger.panelClosingActions))
        .subscribe(x => this.nextPage.next())
    }, 0)
  }

  displayFn(item: Item) {
    return item ? item.name : ''
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/autocomplete/autocomplete-paginated.component.ts